<th scope="row" class="border-bold-left border-bold-right">
{{rowHeaderKey | translate}}</th>
@if (laufNrAusgechlossenenPers === 'None') {
  <td class="border-bold-right text-align-right"></td>
}
@if (laufNrAusgechlossenenPers === 'See-Above') {
  <td class="border-bold-right text-align-left" translate>m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.siehe-oben</td>
}
@if (laufNrAusgechlossenenPers === 'Allowed') {
  <td class=" border-bold-right text-align-left" [matTooltip]="(rowdata?.laufnummerAusgeschlossen | idToLaufnummern: mitarbeiters)">
    {{(rowdata?.laufnummerAusgeschlossen | idToLaufnummern: mitarbeiters)}}
  </td>
}

<td class="text-align-right">{{rowdata?.risikopaareZuUngunstenMaenner}}</td>
<td class="border-bold-right text-align-right">
  {{rowdata?.lohnunterschiedeZuUngunstenMaenner}}
</td>
<td class="text-align-right">{{rowdata?.risikopaareZuUngunstenFrauen}}</td>
<td class="border-bold-right text-align-right">
  {{rowdata?.lohnunterschiedeZuUngunstenFrauen}}
</td>
<td class="text-align-right">{{rowdata?.gesamtscore}}</td>
<td class="border-bold-right text-align-right">{{rowdata?.zuUngunstenFrauen | appGender: crtLocale }}</td>
